import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";

import { PropTypes } from "prop-types";
import HtmlTooltip from "./HtmlTooltip";

export default function Reference({ type }) {
  return (
    <HtmlTooltip
      type={type}
      title={
        <Fragment>
          <p>
            <b>Reference types</b>
          </p>
          <p>
            We use reference types throughout the API. These indicate a
            reference to another object type in our system. This object type is
            structured as an id and name:
            <pre>
              <code>
                {`
{
  “id”: objectId,
  “name”: object name
}`}
              </code>
            </pre>
          </p>
          <p>
            When creating or updating a transaction, you can provide the id of
            the object referenced, or the name if it is an exact match. If you
            are matching by name, omit the id attribute.
          </p>
          <p>
            See our <NavLink to={"/apidoc/References"}>Reference</NavLink>{" "}
            documentation for more information.
          </p>
        </Fragment>
      }
    ></HtmlTooltip>
  );
}
Reference.propTypes = {
  type: PropTypes.string.isRequired,
};
